// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import { VFileUpload } from 'vuetify/labs/components'

export default createVuetify({
  components: {
    VFileUpload,
  },
})
